import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { LocalStorageService } from "../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../services/broadcaster.service";
import { GenericHttpService } from "../../../shared/services/generic-http.service";
import { ApiUrlConstant } from "../../../shared/constants/api-url.constant";

@Injectable({
  providedIn: "root"
})
export class PageDataService {
  constructor(
    private localStorageService: LocalStorageService,
    private broadcaster: BroadcasterService,
    private http: GenericHttpService,
    private apiUrl: ApiUrlConstant
  ) {}

  getDataForAllPages() {
    const options = {
      method: "GET",
      url: "https://dev-e2e-config.delhivery.com/api/v1/client/widget" // `${environment.gateWayHost}${this.apiUrl.PAGE_WIDGET_DATA}`
    };
    this.http.httpRequest(options).subscribe(data => {
      const page_data = JSON.parse(JSON.stringify(data));
      this.broadcaster.publish("PAGE_WIDGET_DATA");
      this.localStorageService.setItem("PAGE_WIDGET_DATA", page_data.data);
    });
  }
}
